import { render, staticRenderFns } from "./flexibleJob_particulars.vue?vue&type=template&id=96d54de6&scoped=true&"
import script from "./flexibleJob_particulars.vue?vue&type=script&lang=js&"
export * from "./flexibleJob_particulars.vue?vue&type=script&lang=js&"
import style0 from "./flexibleJob_particulars.vue?vue&type=style&index=0&id=96d54de6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d54de6",
  null
  
)

export default component.exports